"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.reverse.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _levenstheinSearch = require("./levensthein-search");
var _Input = _interopRequireDefault(require("../Input"));
var _Return = _interopRequireDefault(require("./assets/Return"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// top/down keys ignore immobile hovering mouse
// show up animation

const sortArray = (array, key) => array.sort((p1, p2) => p1[key] < p2[key] ? 1 : p1[key] > p2[key] ? -1 : 0).reverse();
function hasWhiteSpace(s) {
  return /\s/.test(s);
}
const HighlightMatches = _ref => {
  let {
    elem,
    search
  } = _ref;
  const words = elem.split(' ');
  const terms = search.split(' ').filter(w => w.length !== 0);
  const results = [];
  for (const word of words) {
    const termResults = [];
    for (const term of terms) {
      let tolerance = 0;
      if (term.length <= 2) tolerance = 0;
      if (term.length === 3) tolerance = 1;
      if (term.length > 4) tolerance = 2;
      const r = [...(0, _levenstheinSearch.fuzzySearch)(term.toLowerCase(), word.toLowerCase(), tolerance)];
      let sortedResults = sortArray(r, 'dist');
      const s = sortedResults[0];
      termResults.push(s);
    }
    let sortedTermResult = sortArray(termResults, 'dist')[0];
    if (sortedTermResult) {
      const elems = [word.slice(0, sortedTermResult.start), word.slice(sortedTermResult.start, sortedTermResult.end), word.slice(sortedTermResult.end, word.length)];
      elems[1] = "<span class=\"hpd-search-engine-highlighted\">".concat(elems[1], "</span>");
      results.push(elems.join(''));
    } else {
      results.push(word);
    }
  }
  const string = results.join(' ');
  return /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: string
    }
  });
};
const Highlight = _ref2 => {
  let {
    result,
    search
  } = _ref2;
  const fullLength = 68;
  const delta = result.end - result.start;
  const toSlice = result.content;
  const elems = [toSlice.slice(0, result.start), toSlice.slice(result.start, result.end), toSlice.slice(result.end, toSlice.length)];
  if (result.start > fullLength - delta || result.end > fullLength - delta) {
    elems[0] = elems[0].slice(elems[0].length - 40, elems[0].length);
    for (let i = 0; i < 30; i++) {
      if (elems[0][0] !== ' ') {
        elems[0] = elems[0].slice(1, elems[0].length);
      }
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, elems.map((elem, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: elem
  }, index !== 1 && /*#__PURE__*/_react.default.createElement(HighlightMatches, {
    elem: elem,
    search: search
  }), index === 1 && /*#__PURE__*/_react.default.createElement("span", {
    className: "hpd-search-engine-highlighted"
  }, elem))));
};
const useOutsideClick = callback => {
  const ref = _react.default.useRef();
  _react.default.useEffect(() => {
    const handleClick = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    document.addEventListener('click', handleClick, true);
    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [ref]);
  return ref;
};
const SearchEngine = _ref3 => {
  let {
    items = [],
    isOpen,
    onChangeOpen
  } = _ref3;
  const [text, setText] = _react.default.useState('');
  const [results, setResults] = _react.default.useState([]);
  const [activeResult, setActiveResult] = _react.default.useState(0);
  const activeResultRef = _react.default.useRef(activeResult);
  const resultsRef = _react.default.useRef(results);
  const ref1 = _react.default.useRef(null);
  const showRef = _react.default.useRef(isOpen);
  const inputReference = _react.default.useRef(null);
  const ref = useOutsideClick(() => {
    onChangeOpen(false);
  });
  function searchHandler() {
    const filteredTitles = [];
    const normalizeText = text => text.toLowerCase().replace(/[-\s]/g, '');
    const normalizedSearch = normalizeText(text);
    items.forEach(item => {
      // Check for exact matches first (ignoring hyphens and spaces)
      const normalizedTitle = normalizeText(item.title);
      const normalizedContent = normalizeText(item.content);
      let isExactTitleMatch = normalizedTitle.includes(normalizedSearch) && normalizedSearch.length > 2;
      let isExactContentMatch = normalizedContent.includes(normalizedSearch) && normalizedSearch.length > 2;

      // Search in title first with lower tolerance for better exact matching
      const titleResults = [...(0, _levenstheinSearch.fuzzySearch)(text.toLowerCase(), item.title.toLowerCase(), 2)];
      const contentResults = [...(0, _levenstheinSearch.fuzzySearch)(text.toLowerCase(), item.content.toLowerCase(), 3)];
      let bestTitleMatch = null;
      let bestContentMatch = null;
      if (titleResults.length > 0) {
        const sortedTitleResults = sortArray(titleResults, 'dist');
        bestTitleMatch = _objectSpread(_objectSpread({}, sortedTitleResults[0]), {}, {
          matchType: 'title',
          // Exact matches get almost zero distance, very close matches get big boost
          boostedDist: isExactTitleMatch ? 0.001 : sortedTitleResults[0].dist <= 1 ? sortedTitleResults[0].dist * 0.01 : sortedTitleResults[0].dist * 0.1
        });
      }
      if (contentResults.length > 0) {
        const sortedContentResults = sortArray(contentResults, 'dist');
        bestContentMatch = _objectSpread(_objectSpread({}, sortedContentResults[0]), {}, {
          matchType: 'content',
          boostedDist: isExactContentMatch ? 0.5 : sortedContentResults[0].dist
        });
      }

      // Choose the best match overall (title matches get priority due to lower boostedDist)
      const bestMatch = !bestTitleMatch ? bestContentMatch : !bestContentMatch ? bestTitleMatch : bestTitleMatch.boostedDist <= bestContentMatch.boostedDist ? bestTitleMatch : bestContentMatch;
      if (bestMatch) {
        filteredTitles.push({
          title: item.title,
          href: item.href,
          content: item.content,
          distance: bestMatch.boostedDist,
          originalDistance: bestMatch.dist,
          matches: (titleResults.length || 0) + (contentResults.length || 0),
          start: bestMatch.start,
          end: bestMatch.end,
          matchType: bestMatch.matchType
        });
      }
    });
    const newResults = sortArray(filteredTitles, 'distance').slice(0, 8);
    resultsRef.current = newResults;
    setResults(newResults);
  }
  function scrollSelectedIntoView() {
    const view = document.getElementsByClassName('hpd-search-engine-result-parent active')[0];
    if (view) {
      view.scrollIntoView({
        block: 'nearest'
      });
      // view.scrollIntoView({ block: 'center' });
      // document.getElementById('hpd-search-engine').scrollTop += 10;
    }
  }
  _react.default.useEffect(() => {
    setActiveResult(0);
    searchHandler();
  }, [text]);
  _react.default.useEffect(() => {
    activeResultRef.current = activeResult;
  }, [activeResult]);
  _react.default.useEffect(() => {
    showRef.current = isOpen;
    if (isOpen && inputReference.current) inputReference.current.focus();
  }, [isOpen]);
  _react.default.useEffect(() => {
    scrollSelectedIntoView();
  }, [results, activeResult]);
  const downHandler = event => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation();
      if (activeResultRef.current >= resultsRef.current.length - 1) return;
      const newActiveResult = activeResultRef.current + 1;
      setActiveResult(newActiveResult);
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      event.stopPropagation();
      if (activeResultRef.current === 0) return;
      const newActiveResult = activeResultRef.current - 1;
      setActiveResult(newActiveResult);
    }
    if (event.key === 'Enter' && resultsRef.current.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      document.location.href = resultsRef.current[activeResultRef.current].href;
    }
    if (event.metaKey && event.key === 'k') {
      event.preventDefault();
      event.stopPropagation();
      if (showRef.current) return onChangeOpen(false);
      onChangeOpen(true);
    }
    if (event.key === 'Escape' && showRef.current) {
      onChangeOpen(false);
    }
  };
  _react.default.useEffect(() => {
    window.addEventListener("keydown", downHandler);
    return () => {
      window.removeEventListener("keydown", downHandler);
    };
  }, []);
  if (!isOpen) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-modal-overlay"
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "hpd-search-engine".concat(!results || results.length === 0 ? ' no-result' : '', " mt-1em")
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    value: text,
    onChange: setText,
    forwardRef: inputReference,
    placeholder: "Search docs",
    autoFocus: true,
    icon: "search"
  }), results.length === 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-5em"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center justify-content-center color-text-secondary font-size-15px"
  }, !!text && results.length === 0 && /*#__PURE__*/_react.default.createElement("span", {
    className: "hpd-no-results-text"
  }, "No results for ", "\"".concat(text, "\"")), text.length === 0 && results.length === 0 && /*#__PURE__*/_react.default.createElement("span", null, "Type something to search"))), results.length !== 0 && /*#__PURE__*/_react.default.createElement("div", {
    id: "hpd-search-engine",
    className: "hpd-search-engine-results",
    ref: ref1
  }, results.map((result, index) => /*#__PURE__*/_react.default.createElement("a", {
    className: "hpd-search-engine-result-parent".concat(activeResult === index ? ' active' : ''),
    key: result.title
    // onMouseEnter={() => setActiveResult(index)}
    ,
    href: result.href
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "hpd-search-engine-result".concat(activeResult === index ? ' active' : ''),
    onMouseEnter: () => setActiveResult(index)
    // href={result.href}
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex gap-05em overflow-hidden flex-direction-column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-search-engine-result-title"
  }, result.matchType === 'title' ? /*#__PURE__*/_react.default.createElement(Highlight, {
    result: _objectSpread(_objectSpread({}, result), {}, {
      content: result.title
    }),
    search: text
  }) : /*#__PURE__*/_react.default.createElement(HighlightMatches, {
    elem: result.title,
    search: text
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-search-engine-result-content color-text-secondary"
  }, result.matchType === 'content' ? /*#__PURE__*/_react.default.createElement(Highlight, {
    result: result,
    search: text
  }) : /*#__PURE__*/_react.default.createElement(HighlightMatches, {
    elem: result.content,
    search: text
  }))), /*#__PURE__*/_react.default.createElement(_Return.default, {
    className: "return-icon",
    width: "28px"
  })))))));
};
var _default = exports.default = SearchEngine;